// import interfaces.
import {
    IEndorsementValidationController
} from '../Interfaces/ControllerInterfacesBarrel';
// import api models.
import {
    AllowedEndorsementDateRange,
    EndorsementEligibilityStatus,
} from '@app/models/api';

export default class MockEndorsementValidationController implements IEndorsementValidationController {

    public constructor() {

    }

    public async getEndorsementEligibilityStatus(policyId: number): Promise<EndorsementEligibilityStatus> {
        throw new Error('Method not implemented.');
    }
    
    public async getAllowedEndorsementDateRange(endorsementId: number): Promise<AllowedEndorsementDateRange> {
        throw new Error('Method not implemented.');
    }

}
